import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { alertModal } from '@apply/ui';
import { useAuthentication } from '../../LoginPage';
import React, { useState, useEffect } from 'react';
import { NumericFormat } from 'react-number-format';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { BusinessAndPeopleApi } from '@apply/api';
import { AdditionalPeopleRoleTypeOptions } from '../constants/AdditionalPeopleRoleTypeOptions';
import { EntityOwnerPersonWorkTimeTypeOptions } from '../constants/EntityOwnerPersonWorkTimeTypeOptions';
import { OfficerTitleTypeOptions } from '../constants/OfficerTitleTypeOptions';
import { OfficerTitleType } from '../constants/OfficerTitleType';
import { BooleanTypeOptions } from '../constants/BooleanTypeOptions';
import ButtonGroup from 'devextreme-react/button-group';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { AdditionalPeopleRoleType } from '../constants/AdditionalPeopleRoleType';

interface IEditAdditionalPersonModal {
    isOpen: boolean;
    onCloseCallback?: () => void;
    applicationInsights: ApplicationInsights;
    selectedBusinessId: any;
    selectedBusinessName: string;
    personId: any;
}
export const EditAdditionalPersonModal: React.FC<IEditAdditionalPersonModal> = (props) => {
    const businessAndPeopleApi = new BusinessAndPeopleApi.BusinessAndPeopleApi(props.applicationInsights);

    const { authentication, isFeatureEnabled } = useAuthentication();
    const [validation, set_validation] = useState(undefined);
    const [loadingMessage, set_loadingMessage] = useState('');
    const [loadingOpen, set_loadingOpen] = useState(false);
    const [saveEnabled, set_saveEnabled] = useState(false);

    const [person, set_person] = useState(null);
    const [canContinue, set_canContinue] = useState(true);

    const [businessId, set_businessId] = useState<number>(0);

    const [role, set_role] = useState(AdditionalPeopleRoleType.Officer);
    const [officerTitle, set_officerTitle] = useState<number>();
    const [titleOther, set_titleOther] = useState<string>('');
    const [firstName, set_firstName] = useState<string>('');
    const [middleName, set_middleName] = useState<string>('');
    const [lastName, set_lastName] = useState<string>('');
    const [suffix, set_suffix] = useState<string>('');
    const [phoneNumber, set_phoneNumber] = useState<string>('');
    const [email, set_email] = useState<string>('');
    const [workTime, set_workTime] = useState<typeof EntityOwnerPersonWorkTimeTypeOptions>([]);
    const [guarantor, set_guarantor] = useState<typeof BooleanTypeOptions>([]);

    useEffect(() => {
        set_businessId(props.selectedBusinessId);
    }, [props.selectedBusinessId]);

    const loadDetails = async (id: number) => {
        // set_loadingMessage("Loading...");
        // set_loadingOpen(true);
        // const response = await businessAndPeopleApi.getAdditionalPerson(id);
        // if (!response || response.statusCode !== 200) {
        //   return;
        // }
        // set_person(response.result);
    };

    useEffect(() => {
        async function personIdChanged() {
            resetState();
            if (!props.personId || props.personId <= 0) {
                set_person(null);
                return;
            }

            await loadDetails(props.personId);
            set_loadingOpen(false);
        }

        personIdChanged();
    }, [props.personId]);

    useEffect(() => {
        setState(person);
    }, [person]);

    useEffect(() => {
        let fieldsValid = false;

        fieldsValid =
            firstName !== '' &&
            lastName !== '' &&
            ((officerTitle == OfficerTitleType.Other && titleOther !== '') || officerTitle !== OfficerTitleType.Other) &&
            workTime.length !== 1 &&
            guarantor.length !== 1;

        set_canContinue(fieldsValid);
    }, [officerTitle, titleOther, firstName, lastName, workTime, guarantor]);

    const setState = (person: any) => {
        if (!person) {
            return;
        }
        set_role(person.role);
        set_officerTitle(person.officerTitle);
        set_titleOther(person.titleOther);
        set_firstName(person.firstName);
        set_middleName(person.middleName);
        set_lastName(person.lastName);
        set_suffix(person.suffix);
        set_phoneNumber(person.phoneNumber);
        set_email(person.email);
        set_workTime(person.workTime);
        set_guarantor(person.guarantor);
    };

    const resetState = () => {
        set_businessId(0);
        set_role(AdditionalPeopleRoleType.Officer);
        set_officerTitle(undefined);
        set_titleOther('');
        set_firstName('');
        set_middleName('');
        set_lastName('');
        set_suffix('');
        set_phoneNumber('');
        set_email('');
        set_workTime([]);
        set_guarantor([]);
    };

    const getSuccessMessage = (id: number) => {
        if (id === 0) {
            return 'Your Additional Person was added successfully.';
        } else {
            return 'Your Additional Person was updated successfully';
        }
    };

    const getGeneralErrorMessage = () => {
        return 'An error has occurred while communicating with our server.  Please try your operation again.';
    };

    const handleClose = () => {
        set_person(null);
        set_validation(undefined);
        resetState();
        props.onCloseCallback(null);
    };

    const cancelAdditionalPerson = () => {
        set_person(null);
        set_validation(undefined);
        resetState();
        props.onCloseCallback(null);
    };

    const validatePerson = async () => {
        // //Check should validate whether the name already exists (existing person / user) already exists in the system / business - confirm requirements
        // set_loadingMessage("Validating...");
        // set_loadingOpen(true);
        // set_validation(undefined);
        // try {
        //   const model = {
        //     businessId,
        //     firstName,
        //     lastName,
        //   };
        //   const response = await businessAndPeopleApi.validatePerson(model);
        //   if (response.statusCode !== 200 || !response.result) {
        //     set_loadingOpen(false);
        //     return false;
        //   }
        //   if (response.result.hasErrors || response.result.hasWarnings) {
        //     set_validation(response.result);
        //     set_loadingOpen(false);
        //     return false;
        //   }
        //   return true;
        // } catch (ex) {
        //   set_loadingOpen(false);
        //   set_validation(undefined);
        //   alertModal({
        //     message:
        //       getGeneralErrorMessage(),
        //   });
        //   return false;
        // }
    };

    const savePerson = async () => {
        // try {
        //     const isValid = await validatePerson();
        //     if (!isValid) {
        //         return;
        //     }
        //     const model = {
        //         personid: props.personId,
        //         businessId: props.selectedBusinessId ?? 0,
        //         role,
        //         officerTitle,
        //         titleOther,
        //         firstName,
        //         middleName,
        //         lastName,
        //         suffix,
        //         phoneNumber,
        //         email,
        //         workTime: workTime[0].id,
        //         guarantor: guarantor[0].id,
        //     };
        //     const response = await businessAndPeopleApi.saveAdditionalPerson(model);
        //     if (response.statusCode !== 200 || !response.result) {
        //         set_loadingOpen(false);
        //         alert(response.errors[0]);
        //         return false;
        //     }
        //     set_loadingOpen(false);
        //     alertModal({
        //         title: 'Success',
        //         message: getSuccessMessage(model.personid),
        //         onConfirm: () => {
        //             handleClose();
        //         },
        //     });
        // } catch (ex) {
        //     set_loadingOpen(false);
        //     set_validation(undefined);
        //     alertModal({
        //         message: getGeneralErrorMessage(),
        //     });
        //     return false;
        // }
    };

    return (
        <div>
            <Dialog
                open={props.isOpen}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                maxWidth='md'
            >
                <DialogContent>
                    <div className='modal-container'>
                        <div className='modal-backdrop'></div>
                        <div
                            className='modal'
                            role='dialog'
                            style={{ width: '500px', maxWidth: '80vw' }}
                        >
                            <div
                                className='modal-dialog'
                                role='document'
                            >
                                <div
                                    className='page-header'
                                    role='banner'
                                >
                                    <h1>{!props.personId && props.personId === 0 ? 'Add Person' : 'Edit Person'}</h1>
                                    <button
                                        type='button'
                                        className='close'
                                        data-dismiss='modal'
                                        aria-label='Close'
                                        onClick={handleClose}
                                    >
                                        <span aria-hidden='true'>&times;</span>
                                    </button>
                                </div>
                                <div className='modal-content'>
                                    <div className='modal-body'>
                                        <div
                                            className='standard-form'
                                            style={{
                                                padding: 0,
                                            }}
                                        >
                                            <div
                                                className='scrollable-content'
                                                style={{ margin: '10px' }}
                                            >
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <div
                                                            style={{
                                                                padding: '5px',
                                                                border: '1px solid lightgrey',
                                                                borderRadius: '7px',
                                                                width: '100%',
                                                                backgroundColor: 'ghostwhite',
                                                                alignContent: 'center',
                                                            }}
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faExclamationTriangle}
                                                                style={{ paddingLeft: '5px', paddingTop: '5px', float: 'left' }}
                                                            />
                                                            <div style={{ float: 'right', width: '90%', fontSize: 'small' }}>
                                                                Please only enter people employed by <br />
                                                                {props.selectedBusinessName
                                                                    ? props.selectedBusinessName
                                                                    : 'the parent business'}{' '}
                                                                or one of its subsidiaries.
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-8'>
                                                        <label htmlFor='firstName'>
                                                            First Name
                                                            <span className='req'>*</span>
                                                        </label>
                                                        <input
                                                            type='text'
                                                            id='firstName'
                                                            value={firstName}
                                                            onChange={(e) => set_firstName(e.target.value)}
                                                            required={true}
                                                            maxLength={50}
                                                        />
                                                    </div>
                                                    <div className='columns small-12 large-4'>
                                                        <label htmlFor='middleName'>Middle</label>
                                                        <input
                                                            type='text'
                                                            id='middleName'
                                                            value={middleName}
                                                            onChange={(e) => set_middleName(e.target.value)}
                                                            required={false}
                                                            maxLength={50}
                                                        />
                                                    </div>
                                                    <div className='columns small-12 large-8'>
                                                        <label htmlFor='lastName'>
                                                            Last Name
                                                            <span className='req'>*</span>
                                                        </label>
                                                        <input
                                                            type='text'
                                                            id='lastName'
                                                            value={lastName}
                                                            onChange={(e) => set_lastName(e.target.value)}
                                                            required={true}
                                                            maxLength={50}
                                                        />
                                                    </div>
                                                    <div className='columns small-12 large-4'>
                                                        <label htmlFor='suffix'>Suffix</label>
                                                        <input
                                                            type='text'
                                                            id='suffix'
                                                            value={suffix}
                                                            placeholder='JR, etc.'
                                                            onChange={(e) => set_suffix(e.target.value)}
                                                            required={false}
                                                            maxLength={20}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-6'>
                                                        <label htmlFor='role'>
                                                            Role
                                                            <span className='req'>*</span>
                                                        </label>
                                                        <select
                                                            id='role'
                                                            required={true}
                                                            value={role}
                                                            onChange={(e) => set_role(parseInt(e.target.value))}
                                                        >
                                                            {AdditionalPeopleRoleTypeOptions.map((x) => (
                                                                <option
                                                                    key={x.id}
                                                                    value={x.id}
                                                                >
                                                                    {x.text}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    {role == AdditionalPeopleRoleType.Officer && (
                                                        <div className='columns small-12 large-6'>
                                                            <label htmlFor='officerTitle'>
                                                                Officer Title
                                                                <span className='req'>*</span>
                                                                <span className='helper'>
                                                                    <span className='tooltip-trigger'>
                                                                        <FontAwesomeIcon icon={faCircleQuestion} />
                                                                    </span>
                                                                    <span className='text'>
                                                                        Officers are high-level management executives hired by the
                                                                        business's owner or board of directors. Officers can be
                                                                        shareholders and directors but don't necessarily have to
                                                                        be.
                                                                        <br />
                                                                        <br />
                                                                        Examples include the organization's Chief Executive
                                                                        Officer (CEO), Chief Financial Officer (CFO), Treasurer,
                                                                        President, Vice President, and Secretary.
                                                                        <br />
                                                                        <br />
                                                                        They have the authority to act on behalf of the
                                                                        corporation, including contract authority.
                                                                    </span>
                                                                </span>
                                                            </label>
                                                            <select
                                                                id='officerTitle'
                                                                required={true}
                                                                value={officerTitle}
                                                                onChange={(e) => set_officerTitle(parseInt(e.target.value))}
                                                            >
                                                                {OfficerTitleTypeOptions.map((x) => (
                                                                    <option
                                                                        key={x.id}
                                                                        value={x.id}
                                                                    >
                                                                        {x.text}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    )}

                                                    {(officerTitle == OfficerTitleType.Other ||
                                                        role == AdditionalPeopleRoleType.RegularEmployee) && (
                                                        <div className='columns small-12 large-6'>
                                                            <label htmlFor='titleOther'>
                                                                Title <span className='req'>*</span>
                                                            </label>
                                                            <span className='helper'>
                                                                <span className='tooltip-trigger'>
                                                                    <FontAwesomeIcon icon={faCircleQuestion} />
                                                                </span>
                                                                <span className='text'>
                                                                    Specific title for a person within your company. e.g.
                                                                    Administrator
                                                                </span>
                                                            </span>
                                                            <input
                                                                id='titleOther'
                                                                type='text'
                                                                required={true}
                                                                value={titleOther}
                                                                onChange={(event) => set_titleOther(event.target.value)}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-5'>
                                                        <label htmlFor='phone'>Phone Number</label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>
                                                                10 digit phone number, including area code, without symbols e.g.
                                                                5551234567.
                                                            </span>
                                                        </span>
                                                        <span>
                                                            <NumericFormat
                                                                format='(###) ###-####'
                                                                mask='_'
                                                                placeholder='(212) 555-1212'
                                                                name='phone'
                                                                value={phoneNumber}
                                                                onValueChange={(values) => {
                                                                    set_phoneNumber(values.value);
                                                                }}
                                                                required={false}
                                                            />
                                                        </span>
                                                    </div>
                                                    <div className='columns small-12 large-7'>
                                                        <label htmlFor='email'>Email</label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>
                                                                The email address. i.e. johnsmith@email.com
                                                            </span>
                                                        </span>
                                                        <input
                                                            type='email'
                                                            id='email'
                                                            value={email}
                                                            onChange={(e) => set_email(e.target.value)}
                                                            required={false}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='workTime'>
                                                            Is this person full time or part time?
                                                            <span className='req'>*</span>
                                                        </label>
                                                        <ButtonGroup
                                                            id='workTime'
                                                            items={EntityOwnerPersonWorkTimeTypeOptions}
                                                            stylingMode='outlined'
                                                            selectionMode='single'
                                                            selectedItems={workTime}
                                                            onSelectedItemsChange={(e) => set_workTime(e)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='guarantor'>
                                                            Is this Person willing to be a Guarantor?
                                                            <span className='req'>*</span>
                                                        </label>
                                                        <ButtonGroup
                                                            id='guarantor'
                                                            items={BooleanTypeOptions}
                                                            stylingMode='outlined'
                                                            selectionMode='single'
                                                            selectedItems={guarantor}
                                                            onSelectedItemsChange={(e) => set_guarantor(e)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='modal-content-actions'>
                                                <button
                                                    type='button'
                                                    data-testid='accept-button'
                                                    className='button primary'
                                                    style={{
                                                        width: 150,
                                                    }}
                                                    onClick={cancelAdditionalPerson}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type='button'
                                                    data-testid='accept-button'
                                                    className='button primary'
                                                    style={{
                                                        width: 150,
                                                    }}
                                                    onClick={savePerson}
                                                    disabled={!canContinue || !saveEnabled}
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions></DialogActions>
            </Dialog>
        </div>
    );
};
